export default __webpack_public_path__ + "static/media/Campaign - Options.28d6ac75.svg";